import PropTypes from 'prop-types';
import { path } from 'ramda';
import React from 'react';
import { KeyCodes } from 'reactApp/constants/KeyCodes';
import { execCommand, getClipboadText, noop } from 'reactApp/utils/helpers';

import styles from './ContentEditable.css';

export class ContentEditable extends React.Component {
    propTypes = {
        value: PropTypes.string,
        onEdit: PropTypes.func,
        onClick: PropTypes.func,
    };

    static defaultProps = {
        onEdit: () => Promise.resolve(),
        onClick: noop,
    };

    refInstance = React.createRef();

    getText = () => path(['current', 'textContent'], this.refInstance);

    shouldComponentUpdate(nextProps) {
        return nextProps.value !== this.getText();
    }

    componentDidUpdate() {
        if (this.props.value !== this.getText()) {
            this.refInstance.current.textContent = this.props.value;
        }
    }

    emitChange = () => {
        const value = this.getText();
        if (this.props.onEdit && value !== this.lastValue) {
            this.props
                .onEdit({ value })
                .then(() => {
                    this.lastValue = value;
                })
                .catch(() => {
                    this.refInstance.current.textContent = this.props.value;
                });
        }
    };

    handleKeyDown = event => {
        const keyCode = event.keyCode || event.which;

        if (keyCode === KeyCodes.DOM_VK_ENTER || keyCode === KeyCodes.DOM_VK_RETURN) {
            event.returnValue = false;
            if (event.preventDefault) {
                event.preventDefault();
                event.target.blur();
            }
        }
        if (keyCode === KeyCodes.DOM_VK_ESCAPE) {
            event.returnValue = false;
            if (event.preventDefault) {
                event.preventDefault();
                this.refInstance.current.textContent = this.props.value;
                event.target.blur();
            }
        }
    };

    handlePaste = event => {
        event.preventDefault();
        let text = getClipboadText(event);
        if (!text) {
            return;
        }
        execCommand('insertText', text.replace(/[\r\n]+/gm, ''));
    };

    render() {
        const { value, onClick } = this.props;
        return (
            <div
                className={styles.root}
                id="contenteditable"
                ref={this.refInstance}
                onBlur={this.emitChange}
                onPaste={this.handlePaste}
                contentEditable
                onKeyDown={this.handleKeyDown}
                onClick={onClick}
            >
                {value}
            </div>
        );
    }
}
